import Footer from '../components/Footer';
import TopNavbar from '../components/Navbar/TopNavbar';
import '../index.css';
import ContentHelp from './../components/ContentHelp';


function Help() {
  return (
    <div className='d-flex flex-column'>
      <TopNavbar />
      <ContentHelp />
      <Footer />
    </div>
  );
}

export default Help;